import { render, staticRenderFns } from "./TableRowCogPercent.vue?vue&type=template&id=0f206da0&lang=pug&"
import script from "./TableRowCogPercent.vue?vue&type=script&lang=js&"
export * from "./TableRowCogPercent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f206da0')) {
      api.createRecord('0f206da0', component.options)
    } else {
      api.reload('0f206da0', component.options)
    }
    module.hot.accept("./TableRowCogPercent.vue?vue&type=template&id=0f206da0&lang=pug&", function () {
      api.rerender('0f206da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/TableRowCogPercent.vue"
export default component.exports